export const submitSearchEventToGoogleAnalytics = function (
  searchTerm: string,
  searchResultCount: number,
  searchParams: unknown[],
) {
  console.debug(
    "Submitting search event to Google Analytics with search term:",
    searchTerm,
    "and result count:",
    searchResultCount,
  );
  // @ts-expect-error Google Analytics
  const datalayer = window.dataLayer || [];
  const searchEventObject = {
    event: "ga4Event",
    event_name: "view_search_results",
    view_search_results: {
      search_term: searchTerm,
      search_results: searchResultCount,
      search_params: searchParams,
    },
  };
  console.debug("Search Event Object:", searchEventObject);
  const success = datalayer.push(searchEventObject);
  if (!success) {
    console.warn("Failed to push event to Google Analytics");
  }
};
